var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32h-0.531l3.333-8.932h4.531c0.802 0 1.599-0.667 1.865-1.333l3.604-9.734c0.531-1.599-0.401-2.932-2-2.932h-6.271l-8.13 22.531c-7.203-1.734-12.401-8-12.401-15.599 0-7.333 4.932-13.469 11.734-15.469l-3.068 8.536-5.198 14h3.333l4.266-11.87h2.531l-4.266 11.87h3.333l4-11.068c0.531-1.599-0.266-2.932-2-2.932h-2.667l3.333-9.068h0.667c8.802 0 16 7.198 16 16s-7.198 16-16 16zM25.734 11.068h-2.536l-3.599 9.734h2.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/hp.901a7521b99bf2134882ddf8672f1696.svg";
export { ForwardRef as ReactComponent };